import type { CookieOptions } from 'nuxt/app';

export const useSyncedCookie = <T>(
    name: string,
    options?: CookieOptions<T>
) => {
    let cookie = useCookie<T>(name, options);
    let givenOptions = options;

    return customRef<{ value: T; options?: CookieOptions }>(
        (track, trigger) => {
            return {
                get() {
                    track();
                    return {
                        value: cookie.value,
                        options: givenOptions,
                    };
                },
                set({ value, options }) {
                    cookie = useCookie(name, options);
                    cookie.value = value;
                    givenOptions = options;
                    trigger();
                },
            };
        }
    );
};
